import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@Component({
    selector: 'app-checkMobile',
    templateUrl: './checkMobile.component.html',
    styleUrls: ['./checkMobile.component.scss'],
    providers: [ConfirmationService, MessageService],
})
export class CheckmobileComponent implements OnInit {
    public loggedInUser;
    public isLoggedIn: boolean = false;
    public userId;
    public profileDetails;
    isMobileDevice: boolean;
    public referalcode;
    isAndroid: boolean;
    isiOS: boolean;
    constructor(
        private tokenStorage: TokenStorageService,
        private route: ActivatedRoute,
        private breakpointObserver: BreakpointObserver,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.referalcode = params.ref;            
            this.tokenStorage.saveReferalcode(this.referalcode);
        });        
        this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
            this.isMobileDevice = result.matches;
            //console.log(this.isMobileDevice, "ismobile");
            if (!this.isMobileDevice) {
                this.router.navigateByUrl("sign-up");
            } else {
                const userAgent = window.navigator.userAgent.toLowerCase();
                this.isAndroid = userAgent.includes('android');
                this.isiOS = userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');
                if(this.isAndroid){
                    //console.log(this.isAndroid,"android");
                    window.parent.close();
                    window.location.replace('https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share');                    
                } else if(this.isiOS){
                    //console.log(this.isiOS,"ios");
                    window.parent.close();
                    window.location.replace('https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254');
                } else {
                    this.router.navigateByUrl("sign-up");
                }
                //this.router.navigateByUrl("sign-up");
            }
        });


        this.loggedInUser = this.tokenStorage.getUser();
        // if (this.loggedInUser.userdata != undefined) {
        //     this.isLoggedIn = true;
        //     this.userId = this.loggedInUser.userdata.id;
        // }
        // if (this.isLoggedIn == false) {
        //     this.router.navigate(['/']);
        // }

    }
}





